var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoJobs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4112_7251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.035 89.2752V35.6836H3.96484V162.36C3.96484 171.119 11.0659 178.22 19.8242 178.22H156.592L177.625 199.035L193.088 183.969L186.891 177.78C193.857 176.11 199.035 169.838 199.035 162.36V124.298V89.2752Z",
    fill: "#F1FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.035 124.298V35.6836H3.96484V162.36C3.96484 171.119 11.0659 178.22 19.8242 178.22H156.592L177.625 199.035L193.088 183.969L186.891 177.78C193.857 176.11 199.035 169.838 199.035 162.36V124.298Z",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.035 35.6836H3.96484V19.8242C3.96484 11.0655 11.0655 3.96484 19.8242 3.96484H183.176C191.935 3.96484 199.035 11.0655 199.035 19.8242V35.6836Z",
    fill: "#9BD3D5",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7891 19.8242H59.4727",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.527 19.8242H179.211",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 162.36C131.609 162.36 156.017 137.952 156.017 107.844C156.017 77.7351 131.609 53.3271 101.5 53.3271C71.3913 53.3271 46.9834 77.7351 46.9834 107.844C46.9834 137.952 71.3913 162.36 101.5 162.36Z",
    fill: "#FAF7F5",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 146.501C122.85 146.501 140.157 129.194 140.157 107.844C140.157 86.494 122.85 69.1865 101.5 69.1865C80.1502 69.1865 62.8428 86.494 62.8428 107.844C62.8428 129.194 80.1502 146.501 101.5 146.501Z",
    fill: "#E53E3E",
    fillOpacity: 0.7,
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.099 152.226L145.883 163.443L134.036 151.596C138.294 148.42 142.076 144.638 145.252 140.379L157.099 152.226Z",
    fill: "#FAF7F5",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.088 183.969L177.625 199.035L143.781 165.544L159.201 150.125L193.088 183.969Z",
    fill: "#FFDA8F",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3809 125.686C92.3809 122.401 96.3749 119.738 101.302 119.738C106.229 119.738 110.223 122.401 110.223 125.686",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3984 98.3281C90.3984 101.613 87.7358 104.275 84.4512 104.275C81.1666 104.275 78.5039 101.613 78.5039 98.3281",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.496 98.3281C124.496 101.613 121.745 104.275 118.351 104.275C114.957 104.275 112.205 101.613 112.205 98.3281",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4112_7251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 203,
    height: 203,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobs);
export default __webpack_public_path__ + "static/media/NoJobs.fe568fb65f193f743a4357b82e205edc.svg";
export { ForwardRef as ReactComponent };